// Tiny WebAudio synth — no assets, just oscillators. Lazily unlocked on first
// user gesture (browsers block AudioContext before interaction).

let ctx: AudioContext | null = null;
let master: GainNode | null = null;

export function unlockAudio(): void {
  if (ctx) {
    if (ctx.state === 'suspended') void ctx.resume();
    return;
  }
  try {
    ctx = new AudioContext();
    master = ctx.createGain();
    master.gain.value = 0.32;
    master.connect(ctx.destination);
  } catch {
    ctx = null;
  }
}

function blip(
  freq: number,
  endFreq: number,
  dur: number,
  type: OscillatorType,
  vol: number,
  delay = 0,
): void {
  if (!ctx || !master) return;
  const t0 = ctx.currentTime + delay;
  const osc = ctx.createOscillator();
  const g = ctx.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, t0);
  osc.frequency.exponentialRampToValueAtTime(Math.max(20, endFreq), t0 + dur);
  g.gain.setValueAtTime(vol, t0);
  g.gain.exponentialRampToValueAtTime(0.001, t0 + dur);
  osc.connect(g).connect(master);
  osc.start(t0);
  osc.stop(t0 + dur + 0.02);
}

export const sfx = {
  jump: () => blip(330, 520, 0.12, 'square', 0.12),
  land: () => blip(150, 70, 0.08, 'triangle', 0.18),
  echo: () => {
    blip(520, 1040, 0.22, 'sine', 0.2);
    blip(260, 520, 0.3, 'triangle', 0.14, 0.04);
  },
  deny: () => blip(180, 120, 0.14, 'sawtooth', 0.12),
  death: () => {
    blip(420, 60, 0.4, 'sawtooth', 0.2);
    blip(200, 40, 0.5, 'square', 0.1, 0.05);
  },
  door: () => {
    blip(196, 392, 0.3, 'triangle', 0.16);
    blip(392, 784, 0.25, 'sine', 0.1, 0.08);
  },
  button: () => blip(700, 880, 0.07, 'sine', 0.1),
  win: () => {
    blip(523, 523, 0.14, 'sine', 0.18);
    blip(659, 659, 0.14, 'sine', 0.18, 0.12);
    blip(784, 784, 0.2, 'sine', 0.18, 0.24);
    blip(1046, 1046, 0.4, 'sine', 0.16, 0.36);
  },
};
